<template>
  <div class="c--freemium-incompatible-modal">
    <general-modal
      modal-id="freemium-modal"
      :hasCloseButton="true"
      :modalView="viewModal"
      height="unset"
      @onPressClose="onClose"
    >
      <div class="tw-px-4" data-testid="freemium-incompatible-modal">
        <nuxt-img
          src="/assets/images/freemium/freemium-incompatible.svg"
          alt="Freemium Incompatible"
          class="w-auto tw-block tw-mx-auto tw-mb-6"
          loading="lazy"
        />
        <h2 class="tw-text-7 tw-font-semibold tw-text-primary tw-my-6 tw-mx-auto tw-block tw-text-center">
          {{ $t('components.freemium.get-the-app') }}
        </h2>
        <div
          class="tw-my-6 tw-py-6 tw-text-14 tw-leading-[20px] tw-border-0 tw-border-t tw-border-b tw-border-solid tw-border-zinc-150"
        >
          {{ $t('components.freemium.get-the-app-description') }}
        </div>
        <div class="tw-flex tw-justify-between tw-items-center tw-pb-6">
          <nuxt-img
            src="/assets/images/freemium/freemium-app-store-qr.svg"
            alt="Freemium App Store QR"
            class="tw-w-[65px] tw-h-[65px] tw-hidden md:tw-inline"
            loading="lazy"
          />
          <a
            target="_blank"
            rel="noopener"
            href="https://apps.apple.com/app/airalo-esim-store/id1475911720"
            class="tw-flex"
          >
            <nuxt-img
              src="/assets/images/freemium/appstore.svg"
              alt="Freemium App Store QR"
              class="tw-w-[160px] tw-h-[46px]"
              loading="lazy"
            />
          </a>
          <a
            target="_blank"
            rel="noopener"
            href="https://play.google.com/store/apps/details?id=com.mobillium.airalo"
            class="tw-flex"
          >
            <nuxt-img
              src="/assets/images/freemium/googleplay.svg"
              alt="Freemium App Store QR"
              class="tw-w-[160px] tw-h-[46px]"
              loading="lazy"
            />
          </a>
          <nuxt-img
            src="/assets/images/freemium/freemium-google-play-qr.svg"
            alt="Freemium App Store QR"
            class="tw-w-[65px] tw-h-[65px] tw-hidden md:tw-inline"
            loading="lazy"
          />
        </div>
      </div>
    </general-modal>
  </div>
</template>

<script>
  import GeneralModal from '~/components/modals/general-modal'

  export default {
    components: {
      GeneralModal,
    },

    props: {
      viewModal: {
        type: Boolean,
        required: false,
        default: false,
      },
    },

    methods: {
      async onClose() {
        this.$emit('onClose')
      },
    },
  }
</script>
